import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=3e5762f6&"
import script from "./PageSettings.vue?vue&type=script&lang=ts&"
export * from "./PageSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PageSettings.vue?vue&type=style&index=0&id=3e5762f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports